<template>
    <div class="w-views">
      <div class="secondary-menu create-event club">
        <div class="secondary-menu-header">
          <i class="back" @click="returnBack()"></i>
          <div class="title">{{ trans('edit') }}</div>
          <i class="trash" @click="removeClub(clubId)"></i>
        </div>
        <div class="secondary-menu-body">
          <div class="tab-content-wrapper event-category-tabs">
            <div class="tab-content-inner">
              <div class="tab-content">
                <EventCreate v-bind:vars="clubDataProcessed" v-if="clubOriginal && clubOriginal.id" />
              </div>
            </div>
          </div>
        </div>
      </div><!--secondary-menu-->
    </div><!--w-views-->
</template>
  
<script>
import EventCreate from "@clubs/views/widgets/club/create/EventCreate";

import _ from "lodash";
import clubsModule from '@clubs/module/store/type';
import Map from '@buddy/views/widgets/Map.vue';


export default {
    mixins: [
        require('@general/lib/mixin').default,
        require('@general/lib/mixin-clubs').default,
        require('@general/lib/mixin-club-edit').default,
    ],
    data() {
        return {
            id: null,
            title: '',
            club_date: '', //this needs moment globally for vee-validate to work
            time: '',
            description: ``,
            location: '',
            address_type: 'full_address',
            address: '',
            addressShow: '',
            addressError: false,
            tags: [],
            newTag: "",
            type: '',
            chemsfriendly: false,
            is_profile_linked: false,
            date: '',

            website: '',
            venue: '',
            name: '',
            contact: '',
            note: '',


            lat: 52.520389,
            lng: 13.40424,

            locality: 'Berlin',
            state: 'Berlin',
            country: 'Germany',
            country_code: 'DE',

            //inner components variables
            mapVisible: null,
            mapFirstTime: true,
            //selected photos for club
            selectedPhotos: [],
            selectedVideos: [],
            deletedPhotos: [],
            deletedVideos: [],
            defaultEventPhoto: 'url("/assets/img/default_180x180.jpg") center / cover',

            //slim
            croppers: [],
            editPhotoId: null,
            slimOptions: this.defaultSlimOptions(),
            step4NextDisabled: true,
            preview_photo: [],
            textarea: {
                rows: 1,
                height: 45,
                scrollHeight: null,
                baseScrollHeight: 0,
            },
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }]
            ],
            descriptionMaxLength: 3000,
            backFlag: false
        }
    },
    props: ['clubId'],
    components: {
        Map,
        EventCreate
    },
    computed: {
        clubOriginal(){
            return this.$store.getters.getClub(this.clubId)
        },
        clubDataProcessed() {
	        const self = this.$data,
                  that = this;
          self.backFlag =  this.backFlag;

            if (that.clubOriginal && that.clubOriginal.id) {
                for (let key in that.clubOriginal) {
                    if (key === 'photos') {
                        that.clubOriginal[key].forEach(function (photo) {
                            if (that.clubOriginal.photo_small === photo.photo_small) {
                                self.defaultEventPhoto = `url(${photo.photo_small}) center / cover`;
                                self.preview_photo = photo;
                            } else {
                                self.selectedPhotos.push(photo);
                            }
                        });
                    } else if(key === 'videos') {
                        that.clubOriginal[key].forEach(function (video) {
                            self.selectedVideos.push(video);
                        });
                    } else {
                        if (key === "event_date") {
                            self.date = "custom";
                        }

                        if (key === 'address') {
                            self.addressShow = that.clubOriginal[key];
                        }

                        self[key] = that.clubOriginal[key];
                    }
                }
            }

            return self;
        },
        windowHistory() {
            return window.history
        }
    },
    mounted() {
        console.log('[Edit Club mobile] Mounted', {
            clubId: this.clubId,
            club: this.club
        })
        this.$store.dispatch(clubsModule.actions.clubs.loadInfo, {clubId:this.clubId,edit:1});
    },
    activated() {
      this.backFlag = false;
    },
    watch: {
          'clubOriginal': {
            immediate: true,
            handler (){
              if (this.clubOriginal && this.clubOriginal.id && !this.backFlag) {
                this.reset()
                this.prepareData(this.clubOriginal);
              }
            }
          }
      },
    
    methods: {
        returnBack(){
          this.backFlag = true;
          this.$store.dispatch(clubsModule.actions.clubs.loadInfo, {clubId:this.clubId,edit:0}).then(() => {
            if(this.windowHistory.length >= 3){
              this.goBack()
            }else{
              this.goTo(`/club/${this.clubId}`)
            }
          });
        },
        prepareData(data) {
	        const self = this;
            for (let key in data) {
                if (key === 'photos') {
                    data[key].forEach(function (photo) {
                        if (data.photo_small === photo.photo_small) {
                            self.defaultEventPhoto = `url(${photo.photo_small}) center / cover`;
                            self.preview_photo = photo;
                        } else {
                            self.selectedPhotos.push(photo);
                        }
                    });
                } else if(key === 'videos') {
                    data[key].forEach(function (video) {
                        self.selectedVideos.push(video);
                    });
                } else {
                    if (key === "event_date") {
                        this.date = "custom";
                    }

                    if (key === 'address') {
                        this.addressShow = data[key];
                    }

                    this[key] = data[key];
                }
            }
        },
    }
}
</script>
  